module.exports = __webpack_public_path__ + "static/media/icon_sherpax_logo.cb8a5ebd.webp";